import { FaPlusCircle } from "react-icons/fa";
import { FcPicture } from "react-icons/fc";
import { useState, useEffect } from "react";
import Select, { StylesConfig } from "react-select";
import toast from "react-hot-toast";
import { createPortal } from "react-dom";
import logoGM from "assets/images/sitelogo.svg";
import Modal from "react-bootstrap/Modal";
import "./Modal.scss";
import "./Store.scss";
import sendRequest from "hooks/useAxios";
import toastFunction from "utils/toast";
export default function AddStoreModal({
  setForceUpdate,
  showStoreModal,
  setShowStoreModal,
}) {
  const [show, setShow] = useState(false);

  // useState
  const [inputValue, setInptValue] = useState({
    logo: "",
    cover: "",
    title: "",
    address: "",
    tell: "",
    mobile: "",
    desc: "",
    whatsApp: "",
    insta: "",
    city: "",
    province: "",
    user: "",
    type: "",
    // fname:"",
    // lname:"",
    // user_mobile:"",
  });
  console.log("99", inputValue);

  const [inputValueValid, setInptValueValid] = useState({
    logo: true,
    cover: true,
    title: true,
    address: true,
    tell: true,
    mobile: true,
    desc: true,
    whatsApp: true,
    insta: true,
    city: true,
    province: true,
    user: true,
    type: true,

    // fname:true,
    // lname:true,
    // user_mobile:true,
  });
  const [city, setCity] = useState([]);
  const [province, setProvince] = useState([
    { value: " 0", label: "گلستان" },
    { value: "1", label: "تهران" },
  ]);
  const [type, setType] = useState([
    { value: "0", label: "تامین کننده اصلی" },
    { value: "1", label: "تامین کننده عادی" },
  ]);
  const [user, setUser] = useState([]);
  const [displayStatus, setDisplayStatus] = useState("d-none");
  const [newUser, setNewUser] = useState({ fName: "", lName: "", mobile: "" });
  const [newUserValid, setNewUserValid] = useState({
    fName: true,
    lName: true,
    mobile: true,
  });

  // functions
  const changeHandler = (value, type) => {
    setInptValue((prev) => {
      return { ...prev, [type]: value };
    });
  };
  const phoneNumberValidation = (mobile) => {
    return /^09\d{9}$/.test(mobile);
  };
  const ValidationNewUser = () => {
    let temp = true;
    if (newUser.fName) {
      setNewUserValid((prev) => {
        return { ...prev, fName: true };
      });
    } else {
      temp = false;
      setNewUserValid((prev) => {
        console.log("f", temp);

        return { ...prev, fName: false };
      });
    }
    if (newUser.lName) {
      setNewUserValid((prev) => {
        return { ...prev, lName: true };
      });
    } else {
      temp = false;
      setNewUserValid((prev) => {
        console.log("lf", temp);

        return { ...prev, lName: false };
      });
    }
    if (newUser.mobile) {
      setNewUserValid((prev) => {
        return { ...prev, mobile: true };
      });
    } else {
      temp = false;
      setNewUserValid((prev) => {
        console.log("m", temp);

        return { ...prev, mobile: false };
      });
    }
    return temp;
  };
  const Validation = () => {
    let temp = true;
    if (phoneNumberValidation(inputValue.mobile)) {
      setInptValueValid((prev) => {
        return { ...prev, mobile: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("mobile", temp);
        return { ...prev, mobile: false };
      });
    }
    if (tellPattern.test(inputValue.tell)) {
      setInptValueValid((prev) => {
        return { ...prev, tell: true };
      });
    } else if (inputValue.tell != "" && !tellPattern.test(inputValue.tell)) {
      temp = false;

      setInptValueValid((prev) => {
        console.log("tel", temp);

        return { ...prev, tell: false };
      });
    }
    if (inputValue.title) {
      setInptValueValid((prev) => {
        return { ...prev, title: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("titl", temp);

        return { ...prev, title: false };
      });
    }
    if (inputValue.city) {
      setInptValueValid((prev) => {
        return { ...prev, city: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("city", temp);

        return { ...prev, city: false };
      });
    }
    if (inputValue.user) {
      setInptValueValid((prev) => {
        return { ...prev, user: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("usr", temp);

        return { ...prev, user: false };
      });
    }
    if (inputValue.type) {
      setInptValueValid((prev) => {
        return { ...prev, type: true };
      });
    } else {
      temp = false;
      setInptValueValid((prev) => {
        console.log("typ", temp);

        return { ...prev, type: false };
      });
    }
    return temp;
  };
  const toastCustome = (message) => {
    return toast.custom(
      <div
        className="d-flex  "
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "10px",
        }}
      >
        <div>
          <img style={{ width: "40px" }} src={logoGM}></img>
        </div>
        <div style={{ alignSelf: "center", marginRight: "5px" }}>{message}</div>
      </div>
    );
  };
  const ClearInput = () => {
    setInptValue({
      logo: "",
      cover: "",
      title: "",
      address: "",
      tell: "",
      mobile: "",
      desc: "",
      whatsApp: "",
      insta: "",
      city: "",
      province: "",
      user: "",
      type: "",
    });
  };
  const tellPattern = /^0\d{10}$/;

  const sendAddStoreModal = () => {
    let fd = new FormData();
    fd.append("title", inputValue.title);
    fd.append("description", inputValue.desc);
    fd.append("whatsapp", inputValue.whatsApp);
    fd.append("instagram", inputValue.insta);
    fd.append("address", inputValue.address);
    fd.append("logofile", inputValue.logo);
    fd.append("coverfile", inputValue.cover);
    fd.append("tell", inputValue.tell);
    fd.append("mobile", inputValue.mobile);
    fd.append("cityId", inputValue.city.value);
    if (inputValue.user.value == "create") {
      fd.append("fname", newUser.fName);
      fd.append("lname", newUser.lName);
      fd.append("user_mobile", newUser.mobile);
    } else {
      fd.append("admin_id", inputValue.user.value);
      // fd.append("mobile", inputValue.mobile);
    }
    if (inputValue.type.value == "0") {
      fd.append("type", "0");
    } else {
      fd.append("type", "1");
    }

    sendRequest("addshop", fd).then(({ data }) => {
      if (data.status == 1) {
        toastFunction("success", "فروشگاه باموفقیت ثبت شد.");
        setShowStoreModal(false);
        setForceUpdate((prev) => !prev);
        ClearInput();
        setNewUser({ fName: "", lName: "", mobile: "" });
      } else {
        toastFunction("error", "مشکلی در ثبت فروشگاه پیش آمده است.");
      }
    });
  };
  // usEffects and api
  useEffect(() => {
    sendRequest("get_admin_users").then(({ data }) => {
      console.log("adminuser", data);
      setUser([
        { value: "create", label: "کاربر جدید" },
        ...data.users.map((value) => {
          return {
            value: value.id,
            label: value.fname + " " + value.lname + " " + value.mobile,
            mobile: value.mobile,

            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    }, []);
    sendRequest("Find_cities").then(({ data }) => {
      setCity([
        ...data.map((value) => {
          return {
            value: value.id,
            label: value.title,
            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    });
  }, []);

  const modalVar1 = (
    <Modal
      className="StoreModal"
      show={showStoreModal}
      onHide={() => {
        setShowStoreModal(false);
      }}
      size="lg"
    >
      <Modal.Header
        closeButton
        onClick={() => {
          ClearInput();
        }}
      >
        <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
          افزودن فروشگاه
        </h5>
      </Modal.Header>
      <Modal.Body>
        {" "}
        <div
          className="style-container"
          style={{ background: "#f2e2c8", margin: "-16px" }}
        >
          <div className="edit-user-container " style={{ padding: "10px" }}>
            <form id="edit-user-form-data" className=" edit-container">
              <div>
                <div className="d-flex justify-content-center flex-wrap">
                  <div className="">
                    <div className="lable-modal">
                      <label> لوگو</label>
                    </div>
                    <div className="">
                      <label htmlFor="profile-pic">
                        <div className="profile-pic position-relative">
                          <input
                            className="d-none"
                            type="file"
                            // accept="image/*"
                            id="profile-pic"
                            // value={}
                            onChange={(e) => {
                              console.log("add");

                              setInptValue((prev) => {
                                return { ...prev, logo: e.target.files[0] };
                              });
                            }}
                          />
                          {inputValue.logo ? (
                            <img
                              src={URL.createObjectURL(inputValue.logo)}
                              style={{
                                width: "80px",
                                borderRadius: "10%",
                                height: "80px",
                                overflow: "hidden",
                              }}
                              alt=""
                            />
                          ) : (
                            <FcPicture
                              style={{
                                width: "80px",
                                // borderRadius: "50%",
                                height: "80px",
                                overflow: "hidden",
                              }}
                            />
                          )}

                          <p
                          // style={{
                          //   color: "red",
                          //   fontSize: "13px",
                          //   visibility:
                          //     inputValueValid.logo == ""
                          //       ? "visible"
                          //       : "hidden",
                          // }}
                          >
                            {/* لطفا لوگو فروشگاه را وارد کنید. */}
                          </p>
                          <label
                            htmlFor="AddProfilePic"
                            className="position-absolute containBoxdark"
                            style={{
                              right: "8px",
                              top: "0px",
                              cursor: "pointer",
                            }}
                          >
                            <FaPlusCircle />
                          </label>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  className="edit-user-item mt-2 row p-2"
                  style={{ marginTop: "auto" }}
                >
                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="title"> عنوان</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="title"
                        name="title"
                        className="input-modal"
                        value={inputValue.title}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, title: e.target.value };
                          });
                        }}
                      ></input>
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.title == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا عنوان فروشگاه را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="covr"> کاور</label>
                    </div>
                    <div className="">
                      <input
                        type="file"
                        id="covr"
                        name="tel"
                        className="input-modal"
                        // value={inputValue.cover}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, cover: e.target.files[0] };
                          });
                        }}
                      ></input>
                      <p
                      // style={{
                      //   color: "red",
                      //   fontSize: "13px",
                      //   visibility:
                      //     inputValueValid.cover == ""
                      //       ? "visible"
                      //       : "hidden",
                      // }}
                      >
                        {/* لطفا کاور فروشگاه را وارد کنید. */}
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="tel"> تلفن</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="tel"
                        name="tel"
                        required
                        className="input-modal"
                        value={inputValue.tell}
                        onChange={(e) => {
                          console.log(
                            "inputValue",
                            inputValue.tell,
                            !isNaN(inputValue.tell)
                          );
                          if (!isNaN(e.target.value))
                            setInptValue((prev) => {
                              return { ...prev, tell: e.target.value };
                            });
                        }}
                      ></input>
                      <p
                        style={{
                          display: inputValueValid.tell ? "none" : "block",
                          color: "red",
                          fontSize: "13px",
                        }}
                      >
                        تلفن وارد شده اشتباه است .
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="mob"> موبایل</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="mob"
                        name="mob"
                        className="input-modal"
                        value={inputValue.mobile}
                        // value={
                        //   inputValue.userInfo.mobile == undefined
                        //     ? ""
                        //     : inputValue.userInfo.mobile
                        // }
                        onChange={(e) => {
                          console.log(
                            "inputValue",
                            inputValue.mobile,
                            !isNaN(inputValue.mobile)
                          );
                          if (!isNaN(e.target.value))
                            setInptValue((prev) => {
                              return { ...prev, mobile: e.target.value };
                            });
                        }}
                      ></input>
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.mobile == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا موبایل را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="instagram"> اینستاگرام</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="instagram"
                        name="instagram"
                        className="input-modal"
                        value={inputValue.insta}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, insta: e.target.value };
                          });
                        }}
                      ></input>
                      <p
                      // style={{
                      //   color: "red",
                      //   fontSize: "13px",
                      //   visibility:
                      //     inputValueValid.insta == ""
                      //       ? "visible"
                      //       : "hidden",
                      // }}
                      >
                        {/* لطفا اکانت اینستاگرام را وارد کنید. */}
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="whatsapp"> واتساپ</label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        id="whatsapp"
                        name="whatsapp"
                        className="input-modal"
                        value={inputValue.whatsApp}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, whatsApp: e.target.value };
                          });
                        }}
                      ></input>
                      <p
                      // style={{
                      //   color: "red",
                      //   fontSize: "13px",
                      //   visibility:
                      //     inputValueValid.whatsApp == ""
                      //       ? "visible"
                      //       : "hidden",
                      // }}
                      >
                        {/* لطفا شماره واتساپ را وارد کنید. */}
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div className="lable-modal">
                      <label htmlFor="city"> نوع فروشگاه</label>
                    </div>
                    <div className="">
                      <Select
                        id="city"
                        className="input-modal"
                        options={type}
                        value={inputValue.type}
                        onChange={(e) => {
                          setInptValue((prev) => {
                            return { ...prev, type: e };
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.type == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا نوع فروشگاه را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div className="lable-modal">
                      <label htmlFor="city"> شهر</label>
                    </div>
                    <div className="">
                      <Select
                        id="city"
                        className="input-modal"
                        options={city}
                        value={inputValue.city}
                        onChange={(e) => {
                          setInptValue((prev) => {
                            return { ...prev, city: e };
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",

                          fontSize: "13px",
                          visibility:
                            inputValueValid.city == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا نام شهر را وارد کنید.
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-lg-4">
                    <div className="lable-modal">
                      <label htmlFor="city"> انتخاب کاربر</label>
                    </div>
                    <div className="">
                      <Select
                        className="input-modal"
                        styles={{ width: "100%" }}
                        id="user"
                        // className="input-modal "
                        options={user}
                        value={inputValue.user}
                        onChange={(value) => {
                          changeHandler(value, "user");
                          if (value.value == "create") {
                            setDisplayStatus("d-block");
                          } else {
                            setDisplayStatus("d-none");
                          }
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            inputValueValid.user == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا نام کاربر را وارد کنید.
                      </p>
                    </div>
                  </div>

                  {/* ایجادکاربر جدید */}
                  <div
                    className={`row d-flex  ${displayStatus} `}
                    style={{
                      border: "1px dashed #6A5ACD",
                      backgroundColor: "#d4e0cc",
                      marginRight: "1px",
                    }}
                  >
                    <div className="col-12 col-lg-4">
                      <div className="label-modal">
                        <label style={{ whiteSpace: "nowrap" }}>
                          نام کاربر
                        </label>
                      </div>
                      <div className="">
                        <input
                          className="input-modal"
                          type="text"
                          value={newUser.fName}
                          onChange={(e) => {
                            setNewUser((prev) => {
                              return { ...prev, fName: e.target.value };
                            });
                          }}
                        ></input>
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              newUserValid.fName == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا عنوان فروشگاه را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4">
                      <div className="label-modal">
                        <label style={{ whiteSpace: "nowrap" }}>
                          نام خانوادگی کاربر
                        </label>
                      </div>
                      <div className="">
                        <input
                          className="input-modal"
                          type="text"
                          value={newUser.lName}
                          onChange={(e) => {
                            setNewUser((prev) => {
                              return { ...prev, lName: e.target.value };
                            });
                          }}
                        ></input>
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              newUserValid.lName == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا عنوان فروشگاه را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4">
                      <div className="label-modal">
                        <label style={{ whiteSpace: "nowrap" }}>
                          موبایل کاربر
                        </label>
                      </div>
                      <div className="">
                        <input
                          className="input-modal"
                          type="text"
                          value={newUser.mobile}
                          onChange={(e) => {
                            setNewUser((prev) => {
                              return { ...prev, mobile: e.target.value };
                            });
                          }}
                        ></input>
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              newUserValid.mobile == "" ? "visible" : "hidden",
                          }}
                        >
                          لطفا عنوان فروشگاه را وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="lable-modal">
                      <label htmlFor="address2"> آدرس</label>
                    </div>
                    <div className="">
                      <textarea
                        type="text"
                        id="address2"
                        name="address"
                        className="input-modal"
                        value={inputValue.address}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, address: e.target.value };
                          });
                        }}
                      ></textarea>
                      <p
                      // style={{
                      //   color: "red",
                      //   fontSize: "13px",
                      //   visibility:
                      //     inputValueValid.address == ""
                      //       ? "visible"
                      //       : "hidden",
                      // }}
                      >
                        {/* لطفا آدرس فروشگاه را وارد کنید. */}
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 ">
                    <div className="lable-modal">
                      <label htmlFor="desc"> توضیحات</label>
                    </div>
                    <div className="">
                      <textarea
                        type="text"
                        id="desc"
                        name="desc"
                        className="input-modal"
                        value={inputValue.desc}
                        onChange={(e) => {
                          // if (!isNaN(e.target.value))
                          setInptValue((prev) => {
                            return { ...prev, desc: e.target.value };
                          });
                        }}
                      ></textarea>
                      <p
                      // style={{
                      //   color: "red",
                      //   fontSize: "13px",
                      //   visibility:
                      //     inputValueValid.desc == "" ? "visible" : "hidden",
                      // }}
                      >
                        {/* لطفا توضیحات فروشگاه را وارد کنید. */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => {
            ClearInput();
            setShowStoreModal(false);
          }}
        >
          بستن
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            console.log("inpuvalue:", inputValue);
            if (inputValue.user.value == "create" && ValidationNewUser()) {
              sendAddStoreModal();
            } else if (Validation()) {
              console.log("dat", inputValue);
              sendAddStoreModal();
            }
          }}
        >
          ذخیره
        </button>
      </Modal.Footer>
    </Modal>
  );
  return createPortal(modalVar1, document.querySelector("#modals"));
}
